/**
 * Dev-only Performance API marks for profiling long-session freezes.
 * No-op in production builds.
 */

function isDevMarksEnabled(): boolean {
  return (
    process.env.NODE_ENV === "development" &&
    typeof performance !== "undefined" &&
    typeof performance.mark === "function"
  );
}

/**
 * Marks when the tab becomes visible during an active focus session.
 */
export function markSessionForegroundRecovery(jobId: string): void {
  if (!isDevMarksEnabled()) return;
  const stamp = Date.now();
  performance.mark(`session:foreground-recovery:${jobId}:${stamp}`);
}

/**
 * Marks session end flow milestones (call from timer/completion code in dev).
 */
export function markSessionEndPhase(phase: string): void {
  if (!isDevMarksEnabled()) return;
  performance.mark(`session:end:${phase}`);
}
